import { EmployeeRole } from '@/types';

/**
 * The roles that carry people-management responsibility for a supplier. This
 * set is the single source of truth for the "is this employee a manager"
 * judgment. Policies read this set and do not list roles themselves. To add a
 * manager-tier role, add it here once.
 *
 * SupplierDefault is excluded on purpose. The EmployeeAccessLevel ladder
 * (utils/access-control.ts) ranks it as admin for PMC, but the role carries
 * no team responsibility.
 */
export const MANAGER_ROLES: ReadonlySet<EmployeeRole> = new Set([
  EmployeeRole.Admin,
  EmployeeRole.Dsm,
]);

export const SUPPLIER_ADMIN_ROLES: ReadonlySet<EmployeeRole> = new Set([
  ...MANAGER_ROLES,
  EmployeeRole.SupplierDefault,
]);
